import React, { useEffect, useState } from "react";

import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "./styles/Design";

import "swiper/css";
import "swiper/css/bundle";
import { withNamespaces } from "react-i18next";
import { Wrapper } from "./styles";

import github_logo from '../assets/images/github.png';
import amazon_logo from '../assets/images/amazon.png';
import paypal_logo from '../assets/images/paypal.png';
import pipedrive_logo from '../assets/images/pipedrive.png';


const OurPartners = ({ t }) => {
  const [width, setWidth] = useState(window.innerWidth);

  const data = [
    github_logo,
    amazon_logo,
    paypal_logo,
    pipedrive_logo
  ];
  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, []);
  return (
    <Wrapper type="container" isSection>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        slidesPerView={width < 700 ? 2 : 4}
        autoplay={{
          delay: 1,
          disableOnInteraction: false,
        }}
        speed={4000}
        mousewheelControl={true}
        loop={true}
      >
        {data.map((elm, i) => (
          <SwiperSlide key={i}>
            <div
              style={{
                width: "10rem",
                height: "7rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image fit="contain" src={elm} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </Wrapper>
  );
};

export default withNamespaces()(OurPartners);
